import { render, staticRenderFns } from "./customer-pallet-account.vue?vue&type=template&id=fd85afc0"
import script from "./customer-pallet-account.vue?vue&type=script&lang=js"
export * from "./customer-pallet-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports